<script>
  import { push } from "svelte-spa-router";

  const handleClick = () => {
    // window.history.back();

    push("/");
  };
</script>

<svg
  on:click={handleClick}
  x="0px"
  y="0px"
  viewBox="0 0 512 512"
  style="enable-background:new 0 0 512 512;"
>
  <linearGradient
    id="SVGID_1_"
    gradientUnits="userSpaceOnUse"
    x1="0"
    y1="258.0002"
    x2="512.0004"
    y2="258.0002"
    gradientTransform="matrix(1 0 0 -1 0 514.0004)"
  >
    <stop offset="0" style="stop-color:#80D8FF" />
    <stop offset="0.16" style="stop-color:#88D1FF" />
    <stop offset="0.413" style="stop-color:#9FBEFE" />
    <stop offset="0.725" style="stop-color:#C4A0FD" />
    <stop offset="1" style="stop-color:#EA80FC" />
  </linearGradient>
  <path
    style="fill:url(#SVGID_1_);"
    d="M5.866,241.843c0.006-0.006,0.011-0.013,0.018-0.019l104.504-104
c7.829-7.791,20.493-7.762,28.285,0.068c7.792,7.829,7.762,20.492-0.067,28.284L68.442,236H492c11.046,0,20,8.954,20,20
c0,11.046-8.954,20-20,20H68.442l70.162,69.824c7.829,7.792,7.859,20.455,0.067,28.284c-7.793,7.831-20.457,7.858-28.285,0.068
l-104.504-104c-0.006-0.006-0.011-0.013-0.018-0.019C-1.968,262.339-1.943,249.635,5.866,241.843z"
  />
  <g />
  <g />
  <g />
  <g />
  <g />
  <g />
  <g />
  <g />
  <g />
  <g />
  <g />
  <g />
  <g />
  <g />
  <g />
</svg>

<style>
  svg {
    cursor: pointer;
    width: 64px;
    margin-left: 16px;
  }
</style>
